import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { GoPloof } from "../components/organisms/GoPloof";
import { ShowActivity } from "../components/organisms/ShowActivity";
import { ShowAvis } from "../components/organisms/ShowAvis";
import MetaMaster from "../components/utils/MetaMaster";
import { HeroHome } from "../stories/organisms/HeroHome";
import { BirthdayHighlight } from "../components/organisms/BirthdayHighlight";

export default function Accueil() {
    return (
        <>
            <HeroHome
                video={
                    "https://player.vimeo.com/progressive_redirect/playback/572113130/rendition/1080p/file.mp4?loc=external&log_user=0&signature=2aa7946c774b5f2b9a3819dced934f7f8d1f672aa714821fccb0b41f9f0c4c25"
                }
            />
            <MetaMaster title="Votre nouvelle expérience aquatique - Vital'Eau" description="La première solution numérique d’activités aquatiques" />
            <section className="section-show-pool-home" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container justifyContent={"center"}>
                        <Grid item lg={8} md={8} sm={12} xs={12}>
                            <div>
                                <h2 className="accueil-histoire-titre" data-title="Notre histoire">
                                    Notre histoire
                                </h2>
                                <p id="accueil-histoire-baseline">comment tout a commencé...</p>
                                <p>
                                    Vital’Eau, piscine familiale à Verrières/Antony, propose des activités aquatiques pour tous : bébés nageurs,
                                    natation enfants, aquagym, aquabike, aquatraining . Un lieu unique créé par un Maître-Nageur passionné !
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <ShowActivity desc />
            <GoPloof />
            <BirthdayHighlight />
            <ShowAvis />
        </>
    );
}
